import React from 'react'
import file from '../../../../Global/assets/Circuts/Series.png'

const Series = () => {
    return (
        <>
            <div id="ExperimentsB" style={{ height: '110vh' }}>
                <div style={{ width: '80%', height: '50%' }}>
                    <img style={{
                      borderRadius:'1vh'  
                    }} src={file} width='100%' height='100%' />
                </div>
                <div style={{ width: '80%', height: '30vh', color: '#fff' }}>
                    <h1>Resistors connected in Series</h1><br />
                    <h6>Observations : </h6><br />
                    <h6>1. There are 3 resistors connected in the Series Connection.</h6><br />
                    <h6>2. Each Resistor is of 10 Ohm's. Total Resistance = 30 Ohm's</h6><br />
                    <h6>3. The Battery used here is a single battery of 24 Volts</h6><br />
                    <h6>4. The ammount of current flowing through the circut is 0.80 Ampere.</h6>
                </div>
            </div>
        </>
    )
}

export { Series }